import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import Login from "./Login";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const [showLogin, setShowLogin] = useState(false);

  // Add a small delay before showing login to handle transient auth state changes
  // This prevents redirecting to login when returning from external apps (like WhatsApp)
  useEffect(() => {
    if (loading) {
      setShowLogin(false);
      return;
    }

    if (!user) {
      // Wait a bit before showing login to allow auth state to stabilize
      // This handles cases where the tab regains focus and auth check is temporarily async
      const timer = setTimeout(() => {
        setShowLogin(true);
      }, 300); // 300ms delay

      return () => clearTimeout(timer);
    } else {
      setShowLogin(false);
    }
  }, [user, loading]);

  if (loading || (!user && !showLogin)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
          <p className="text-muted-foreground">Chargement...</p>
        </div>
      </div>
    );
  }

  if (showLogin) {
    return <Login />;
  }

  return <>{children}</>;
}
